import React from 'react';
import propTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Menu } from 'src/ui/mui-ui-kit';
import classNames from 'classnames';
import { BankLogo } from './BankLogo';

export function SideNav({ isCondensed, links, user }) {
  const navClassName = classNames('side-nav', {
    'is-condensed': isCondensed,
  });

  return (
    <Menu tag="nav" className={navClassName}>
      <BankLogo
        bankName={user.financialInstitutionName}
        logo={user.financialInstitutionLogo}
        logoSmall={user.financialInstitutionLogoSmall}
        isCondensed={isCondensed}
      />
      <ul className="menu-list">
        {links.map(link => (
          <li key={link.label}>
            {!link.submenu ? (
              <NavLink
                to={link.to}
                className={({ isActive }) =>
                  isActive ? 'menu-link is-active' : 'menu-link'
                }
                end={link.exact}
              >
                <span className="icon is-medium">{link.icon}</span>
                <span className="text">{link.label}</span>
              </NavLink>
            ) : (
              <div className="submenu-holder">
                {/* eslint-disable-next-line */}
                <a className="menu-link is-active">
                  <span className="icon is-medium">{link.icon}</span>
                  <span className="text">{link.label}</span>
                </a>
                <ul>
                  {link.submenu.map(sublink => (
                    <li key={sublink.label}>
                      <NavLink
                        to={sublink.to}
                        className={({ isActive }) =>
                          isActive ? 'is-active' : ''
                        }
                        end={sublink.exact}
                      >
                        <span className="icon is-small">{sublink.icon}</span>
                        <span className="text">{sublink.label}</span>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </li>
        ))}
      </ul>
    </Menu>
  );
}

SideNav.propTypes = {
  isCondensed: propTypes.bool.isRequired,
  links: propTypes.arrayOf(
    propTypes.shape({
      label: propTypes.string.isRequired,
      icon: propTypes.oneOfType([propTypes.node, propTypes.element]).isRequired,
      to: propTypes.string,
      exact: propTypes.bool,
    })
  ).isRequired,
  user: propTypes.object.isRequired,
};
